import { getEnv } from './global';

export const API_BASE_URL = () => getEnv('vitaeBackend', 'VITAE_BACKEND');
